<template>
  <div class="fund-hierarchy-container">
    <div class="share-class-fund-details">
      <template v-for="(shareClass, index) in actionFundDetails.shareClassData">
        <mds-section
          :key="index"
          class="fund-replacement-sections"
          collapsible
          expanded
          :title="shareClass.fundName"
          :size="7"
        >
          <div> Select statement for share class fund</div>
          <div class="fund-replacement-left-indentation">
            <div
            class="fund-product-details"
            v-for="(product,i) in shareClass.products"
            :key="i"
            >
              <div>{{product.name}}</div>
              <div> Select statement for product</div>
              <div class="fund-menu-container fund-replacement-left-indentation">
                <mds-table class="fund-replacement-menu-table">
                  <mds-thead>
                    <mds-th> Menu </mds-th>
                    <mds-th> Status </mds-th>
                    <mds-th> Pending </mds-th>
                    <mds-th> Fund Name </mds-th>
                    <mds-th> Ticker </mds-th>
                    <mds-th> Sec ID </mds-th>
                    <mds-th> Category </mds-th>
                  </mds-thead>
                  <mds-tbody>
                    <mds-tr class="fund-replacement-row" v-for="(menu, j) in product.menus" :key="j">
                      <mds-td class="fund-replacement-column"> {{menu}} </mds-td>
                      <mds-td class="fund-replacement-column"> {{actionFundDetails.fundStatus.name}} </mds-td>
                      <mds-td class="fund-replacement-column"> false </mds-td>
                      <mds-td class="fund-replacement-column"> {{actionFundDetails.displayName}} </mds-td>
                      <mds-td class="fund-replacement-column"> {{actionFundDetails.ticker}} </mds-td>
                      <mds-td class="fund-replacement-column"> {{actionFundDetails.secID}} </mds-td>
                      <mds-td class="fund-replacement-column"> {{actionFundDetails.psaCategory.name}} </mds-td>
                    </mds-tr>
                  </mds-tbody>
                </mds-table>
              </div>
            </div>
          </div>
        </mds-section>
      </template>

    </div>
  </div>
</template>

<script>

import {
  MdsTable, MdsThead, MdsTh, MdsTbody, MdsTr, MdsTd,
} from '@mds/data-table';
import MdsSection from '@mds/section';
import { mapState } from 'vuex';

export default {
  name: 'fund-replacement-details',
  components: {
    MdsTable,
    MdsThead,
    MdsTh,
    MdsTbody,
    MdsTr,
    MdsTd,
    MdsSection,
  },
  props: {
    actionFundDetails: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState({
      selectedClient: (state) => state.grid.client.selected,
    }),
  },
  created() {
  },
  methods: {
  },
};
</script>

<style lang="scss">
.fund-hierarchy-container {
  .fund-replacement-left-indentation {
    padding-left: $mds-space-4-x;
  }
  .fund-replacement-menu-table {
    border-collapse: separate;
    border-spacing: 0px $mds-space-2-x;
  }
}

</style>
